// extracted by mini-css-extract-plugin
module.exports = {"recipientCustomTo":"HowToSendYourGiftForm_recipientCustomTo__1EjAg","recipientMessage":"HowToSendYourGiftForm_recipientMessage__3pdCd"};